<script lang="ts">
  import { PlatformTypes } from '@centerhealth/fe/center-kit';

  // Review's text, can contain html tags
  export let text: string;

  // type of the platform (either apple-store or play-store), to show the icon for
  export let platformType: PlatformTypes;
</script>

<div class="text-base leading-tight text-center relative box-border p-3 xl:text-lg">
  {#if platformType}
    <p class="five-stars text-xl mt-1 mb-2">&#x2605;&#x2605;&#x2605;&#x2605;&#x2605;</p>
  {/if}
  <div class="review">{@html text}</div>
</div>

<style>
  /** Stars icons styling **/
  .five-stars {
    color: #f1c40f;
  }
</style>
